/**
 * @generated SignedSource<<550df26ff34870e83a01133101d4b514>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type _sys_property_bulk_upload_input = {
  file_reference_source: string;
  file_source: string;
};
export type useUploadPropertyNewMutation$variables = {
  input: _sys_property_bulk_upload_input;
};
export type useUploadPropertyNewMutation$data = {
  readonly _sys_property_bulk_upload: {
    readonly added_property_codes: ReadonlyArray<string> | null;
    readonly duplicated_count: number;
    readonly updated_property_codes: ReadonlyArray<string> | null;
  } | null;
};
export type useUploadPropertyNewMutation = {
  response: useUploadPropertyNewMutation$data;
  variables: useUploadPropertyNewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "_sys_property_bulk_upload_output",
    "kind": "LinkedField",
    "name": "_sys_property_bulk_upload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "added_property_codes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_property_codes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duplicated_count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadPropertyNewMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUploadPropertyNewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ce08efc37e2d1dcbeb091259933d586c",
    "id": null,
    "metadata": {},
    "name": "useUploadPropertyNewMutation",
    "operationKind": "mutation",
    "text": "mutation useUploadPropertyNewMutation(\n  $input: _sys_property_bulk_upload_input!\n) {\n  _sys_property_bulk_upload(input: $input) {\n    added_property_codes\n    updated_property_codes\n    duplicated_count\n  }\n}\n"
  }
};
})();

(node as any).hash = "fcd739489485d9457a2eca1c5dfb6cc0";

export default node;
